import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import HeaderSession from "../../../../../utils/headerSession";
import Paginacao from "../../../../../utils/paginacao";
import ListaSolicitacao from "../listaSolicitacao";
import RegisterAccess from "../../../../../utils/registerAccess";
import { SolicitacaoLicenciamentoPdf } from "../../../../exports/gerarelatoriopdf";
import { SolicitacoesLicenciamentoExcel } from "../../../../exports/gerarelatorioexcel";
import SearchEstabelecimento from "../../../../../utils/searchEstabelecimento";
import { useSearchParams } from "react-router-dom";
import TabelaLoading from "../../../../../load/tabelaLoading";
// import { useNavigate } from "react-router-dom";

export default function TecnicoArea() {
  //  const navigate = useNavigate()
  // const user = useSelector(state => state.account.user);
  const [tipo, setTipo] = useState("");
  const [status, setStatus] = useState("");
  const [provincia, setProvincia] = useState("");
  const [estabelecimentos, setEstabelecimentos] = useState("");
  const [perPage, setPerPage] = useState(50);
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState("");
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  useEffect(() => {
    // if (user?.funcao === 'Técnico' || user?.funcao === 'Director Geral' || user?.funcao === 'CNP') {
    // } else { navigate('/admin') }
    // || temPermissao(user, ['licenciamentoEstabelecimentoTecnico'])
    //  api.get(`/estabelecimentos?page=${page}&status=Análise&tipoEntrada=Licenciamento&perPage=${perPage}&tipoId=${tipo}&status=${status}&provincia=${provincias}&provincia=${provincia}&sortBy=nome:${order}`)

    setLoading(true);
    setEstabelecimentos("");
    api.get(`/estabelecimentos?page=${page}&status=Análise&tipoEntrada=Licenciamento&perPage=${perPage}&tipoId=${tipo}&status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&sortBy=nome:${order}`)
      .then((response) => {
        // console.log(response)
        setConfigLista(response.data);
        setEstabelecimentos((prevItems) => [
          ...prevItems,
          ...response.data.estabelecimentos,
        ]);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [perPage, order, tipo, status, provincia, dataInicio, dataFim]);

  return (
    <>
      <RegisterAccess page={"area tecnica"} />

      <HeaderSession
        title="LISTA DE SOLICITAÇÕES DE LICENCIAMENTO"
        actions={true}
        handleExportExcel={() =>
          SolicitacoesLicenciamentoExcel(estabelecimentos)
        }
        handleExportPDF={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
      />

      <SearchEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        setProvincia={setProvincia}
        placeholder={"Filtra por nome, número de entrada, data"}
        filtroStatus={false}
        tipo={tipo}
        provincia={provincia}
      />

      {estabelecimentos && (
        <ListaSolicitacao 
          estabelecimentos={estabelecimentos}
          setEstabelecimentos={setEstabelecimentos}
          tipo={tipo} 
          setTipo={setTipo}
          provincia={provincia}
          setProvincia={setProvincia}
          setDataInicio={setDataInicio}
          setDataFim={setDataFim}
          dataInicio={dataInicio}
          dataFim={dataFim}
        >
          <Paginacao
            configLista={configLista}
            lista={estabelecimentos}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}
          />
        </ListaSolicitacao>
      )}

      {loading && <TabelaLoading />}
    </>
  );
}
